import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => {
    return state[NAME];
};

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getIsOpenModal = createSelector(
    getModel,
    (model) => model.isOpenModal,
);

export const getMode = createSelector(getModel, (model) => model.mode);

export const getSaveProposal = createSelector(
    getModel,
    (model) => model.saveProposal,
);

export const getSaveProposalData = createSelector(
    getSaveProposal,
    (saveProposal) => saveProposal.data,
);

export const getIsSavingProposal = createSelector(
    getSaveProposal,
    (saveProposal) => saveProposal.isSaving,
);

export const getSaveProposalErrors = createSelector(
    getSaveProposal,
    (saveProposal) => saveProposal.errors,
);
